import React, { useId } from 'react';
import { twMerge } from 'tailwind-merge';
interface FieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  error?: string;
  autoComplete?: string;
  inputMode?: 'text' | 'email' | 'tel' | 'numeric';
  options?: string[];
  className?: string;
  onDark?: boolean;
}
export function Field({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  error,
  autoComplete,
  inputMode,
  options,
  className,
  onDark = false
}: FieldProps) {
  const id = useId();
  const errorId = `${id}-error`;
  const control = twMerge('h-12 w-full rounded-xl border px-4 text-sm transition-colors duration-150 ease-smooth focus:outline-none focus:ring-2 focus:ring-offset-0', onDark ? 'border-white/25 bg-white/10 text-white placeholder:text-white/50 focus:border-turq-300 focus:ring-turq-300/50' : 'border-ash-300 bg-white text-ash-900 placeholder:text-ash-400 focus:border-royal-600 focus:ring-royal-200', error && (onDark ? 'border-turq-200' : 'border-red-500 focus:ring-red-200'));
  return <div className={twMerge('flex flex-col gap-1.5', className)} data-id="element-214" data-mp="tbtlfd40bvb1">
      <label htmlFor={id} className={twMerge('text-xs font-semibold', onDark ? 'text-white/70' : 'text-ash-600')} data-id="element-215" data-mp="tepi6y44cdxw">
        {label}
      </label>
      {options ? <select id={id} value={value} onChange={e => onChange(e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? errorId : undefined} className={control} data-id="element-216" data-mp="kdrcmbe17yd7">
          <option value="" data-id="element-217" data-mp="17bcfx33wb84v">Select an area</option>
          {options.map(option => <option key={option} value={option} data-id="element-218" data-mp="13b2b3truanrl">
              {option}
            </option>)}
        </select> : <input id={id} type={type} value={value} inputMode={inputMode} autoComplete={autoComplete} placeholder={placeholder} onChange={e => onChange(e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? errorId : undefined} className={control} data-id="element-219" data-mp="1zt8ahm45jfmj" />}
      {error && <p id={errorId} className={twMerge('text-xs', onDark ? 'text-turq-200' : 'text-red-600')} data-id="element-220" data-mp="3fizdqb3hlyg9">
          {error}
        </p>}
    </div>;
}